import { Directive, ElementRef, HostListener, Input, OnInit } from "@angular/core";

@Directive({
    selector: '[vInputMask]'
})
export class InputMaskDirective<T> implements OnInit {
    @Input('v-input-mask') inputMask = '';

    input: HTMLInputElement;

    specialKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab'];
    readOnlyChars = ["/", "@", ":", ".", ","];

    constructor(el: ElementRef) {
        this.input = el.nativeElement;
    }

    ngOnInit(): void {

        this.input.value = this.inputMask;
    }

    @HostListener("keydown", ["$event", "$event.key"])
    onKeyDown(event: KeyboardEvent, key: string): void {

        if (event.metaKey || event.ctrlKey || this.specialKeys.includes(key)) {
            return;
        }

        event.preventDefault();

        const cursorPosition = this.input.selectionStart;

        switch (key) {
            case 'Backspace':
                this.handleDelete(cursorPosition, 'back');
                return;
            case 'Delete':
                this.handleDelete(cursorPosition, 'forward');
                return;


        }

        this.replaceCharacterAtPosition(cursorPosition, key);

    }

    private replaceCharacterAtPosition(position: number, char: string): void {
        const charToReplace = this.input.value.charAt(position);

        if (!charToReplace) {
            return;
        }

        if (this.readOnlyChars.includes(charToReplace)) {
            this.input.setSelectionRange(position + 1, position + 1);
            return this.replaceCharacterAtPosition(position + 1, char);
        }

        const start = this.input.value.substr(0, position);
        const end = this.input.value.substr(position + 1);

        let newInput = start + char + end;
        this.input.value = newInput;
        this.input.setSelectionRange(position + 1, position + 1);
    }

    private handleDelete(position: number, direction: 'back' | 'forward'): void {
        if ((position < 1 && direction === 'back') || (this.input.maxLength != -1 && position >= this.input.maxLength && direction === 'forward') || !position && position != 0) {
            return;
        }

        let indexToDelete = direction === 'back' ? this.findCharIndexToDelete(position) : position;

        this.replaceCharacterAtPosition(indexToDelete, '-');

        if (direction === 'forward') {
            this.input.setSelectionRange(indexToDelete + 1, indexToDelete + 1);
            return;
        }

        this.input.setSelectionRange(indexToDelete, indexToDelete);

    }

    private findCharIndexToDelete(position: number): number {
        if (position < 1 || position > this.input.value.length) {
            return;
        }

        let char = this.input.value.charAt(position - 1);

        if (this.readOnlyChars.includes(char)) {
            return this.findCharIndexToDelete(position - 1);
        }

        return position - 1;
    }
}
